import { AGENT_TRACKER_ROLE } from "vue-app/types/enums";

export const pushNewsletterRoutes = [
  {
    path: "/app/onsite/push-newsletter",
    component: () => import("vue-app/pages/PageReadyFlowLegacy.vue"),
    props: () => ({
      engagementName: "push-newsletter",
      engagementTypeId: 17,
    }),
    children: [
      {
        path: "/app/onsite/push-newsletter",
        component: () => import("../../assets/js/app/twig/TwigPageContainer.vue"),
        props: () => ({
          pageTitle: "GET STARTED",
          pageDesc: "See how this scenario can help you attract customers",
          pageHelper: { name: "push-newsletter" },
        }),
        meta: {
          engagementName: "push-newsletter",
          routeName: "Push Newsletter",
          legacyHref: "/push-newsletter",
          legacyLayout: true,
          noPadding: true,
          skipGlobalLoader: true,
          engagementTypeId: 17,
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
        },
      },
      {
        path: "/app/onsite/push-newsletter/audience",
        component: () => import("../../assets/js/app/engagements/audience/EngagementAudience.vue"),
        props: () => ({
          pageHelper: { name: "push-newsletter" },
        }),
        meta: {
          engagementName: "push-newsletter",
          routeName: "Push Newsletter",
          engagementTypeId: 17,
          legacyLayout: true,
          noPadding: true,
          skipGlobalLoader: true,
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
        },
      },
      {
        path: "/app/onsite/push-newsletter/parameters",
        component: () => import("../../assets/js/app/twig/TwigPageContainer.vue"),
        props: () => ({
          pageTitle: "Adjust",
          pageDesc: "Customize your campaign to boost overall conversion",
          pageHelper: { name: "push-newsletter" },
        }),
        meta: {
          routeName: "Push Newsletter",
          engagementName: "push-newsletter",
          legacyHref: "/push-newsletter/parameters",
          engagementTypeId: 17,
          legacyLayout: true,
          noPadding: true,
          skipGlobalLoader: true,
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
        },
      },
      {
        path: "/app/onsite/push-newsletter/run",
        component: () => import("../../assets/js/app/twig/TwigPageContainer.vue"),
        props: () => ({
          pageTitle: "Run",
          pageDesc: "Allow agents to check for bugs and run scenarios.",
          pageHelper: { name: "push-newsletter" },
        }),
        meta: {
          routeName: "Push Newsletter",
          engagementName: "push-newsletter",
          legacyHref: "/push-newsletter/run",
          engagementTypeId: 17,
          legacyLayout: true,
          noPadding: true,
          skipGlobalLoader: true,
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
        },
      },
      {
        path: "/app/onsite/push-newsletter/design",
        component: () => import("../../assets/js/app/twig/TwigPageContainer.vue"),
        props: () => ({
          pageTitle: "Design",
          pageDesc: "Prepare design for your campaign",
          pageHelper: { name: "push-newsletter" },
        }),
        meta: {
          routeName: "Push Newsletter",
          engagementName: "push-newsletter",
          legacyHref: "/push-newsletter/design",
          engagementTypeId: 17,
          legacyLayout: true,
          noPadding: true,
          skipGlobalLoader: true,
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
        },
      },
      {
        path: "/app/onsite/push-newsletter/reports",
        component: () => import("../../assets/js/app/engagements/reports/EngagementReport.vue"),
        props: () => ({
          pageHelper: { name: "push-newsletter" },
        }),
        meta: {
          routeName: "Push Newsletter",
          engagementTypeId: 17,
          engagementName: "push-newsletter",
          isGlobalNewslettersReport: false,
          isTransactionalEngagement: false,
          skipGlobalLoader: true,
          legacyLayout: true,
          noPadding: true,
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
        },
      },
      {
        path: "/app/onsite/push-newsletter/dates",
        component: () => import("../../assets/js/app/twig/TwigPageContainer.vue"),
        props: () => ({
          pageTitle: "Dates",
          pageDesc: "Adjust the launch date for your campaign",
          pageHelper: { name: "push-newsletter" },
        }),
        meta: {
          engagementName: "push-newsletter",
          routeName: "Push Newsletter",
          engagementTypeId: 17,
          legacyHref: "/push-newsletter/dates",
          legacyLayout: true,
          noPadding: true,
          skipGlobalLoader: true,
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
        },
      },
      {
        path: "/app/onsite/push-newsletter/campaign/create",
        component: () => import("../../assets/js/app/twig/TwigPageContainer.vue"),
        props: () => ({
          pageTitle: "Create",
          pageDesc: "Create new campaign",
          pageHelper: { name: "push-newsletter" },
        }),
        meta: {
          engagementName: "push-newsletter",
          routeName: "Push Newsletter",
          engagementTypeId: 17,
          legacyHref: "/push-newsletter/createNewCampaign",
          legacyLayout: true,
          noPadding: true,
          skipGlobalLoader: true,
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
        },
      },
      {
        path: "/app/onsite/push-newsletter/campaign/edit",
        component: () => import("../../assets/js/app/twig/TwigPageContainer.vue"),
        props: () => ({
          pageTitle: "Edit",
          pageDesc: "Edit current campaign",
          pageHelper: { name: "push-newsletter" },
        }),
        meta: {
          engagementName: "push-newsletter",
          routeName: "Push Newsletter",
          engagementTypeId: 17,
          legacyHref: "/push-newsletter/editCurrentCampaign",
          legacyLayout: true,
          noPadding: true,
          skipGlobalLoader: true,
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
        },
      },
    ],
  },
];
